export default __webpack_public_path__ + "static/media/line-icon.62aaf870.svg";